import { AlignmentType, Paragraph, TextRun } from "docx";
export function introductionText1(certInApplicationName) {
    return new Paragraph({
        spacing: { line: 376 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION security testing team performed Application Security Audit on ${certInApplicationName} Mobile Application. The overall objective and goal of this engagement was to:`,
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })

        ]
    })
}

export function introductionBulletOne(certInApplicationName) {
    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },

        spacing: { line: 400, before: 600 },
        children: [
            new TextRun({
                text: `Identify Vulnerabilities in ${certInApplicationName} Mobile Application.`,
                size: 24,
                font: "Arial",
                bullet: { level: 0 },
                color: '000000',
                italics: false,
                bold: false
            })
        ]
    })
}
export const introductionBulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Recommended steps that need to be in place to mitigate the risks that arise due to the existence of these vulnerabilities.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const introductionBulletThree = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Compliance to industry standards and security best practices.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})